// SMS Template
export const GET_SMS_TEMPLATE_LIST = "GET_SMS_TEMPLATE_LIST";
export const GET_SMS_TEMPLATE_LIST_SUCCESS = "GET_SMS_TEMPLATE_LIST_SUCCESS";
export const GET_SMS_TEMPLATE_LIST_FAIL = "GET_SMS_TEMPLATE_LIST_FAIL";

export const GET_SMS_TEMPLATE_DATA = "GET_SMS_TEMPLATE_DATA";
export const GET_SMS_TEMPLATE_DATA_SUCCESS = "GET_SMS_TEMPLATE_DATA_SUCCESS";
export const GET_SMS_TEMPLATE_DATA_FAIL = "GET_SMS_TEMPLATE_DATA_FAIL";

export const ADD_SMS_TEMPLATE = "ADD_SMS_TEMPLATE";
export const ADD_SMS_TEMPLATE_SUCCESS = "ADD_SMS_TEMPLATE_SUCCESS";
export const ADD_SMS_TEMPLATE_FAIL = "ADD_SMS_TEMPLATE_FAIL";

export const UPDATE_SMS_TEMPLATE = "UPDATE_SMS_TEMPLATE";
export const UPDATE_SMS_TEMPLATE_SUCCESS = "UPDATE_SMS_TEMPLATE_SUCCESS";
export const UPDATE_SMS_TEMPLATE_FAIL = "UPDATE_SMS_TEMPLATE_FAIL";

export const DELETE_SMS_TEMPLATE = "DELETE_SMS_TEMPLATE";
export const DELETE_SMS_TEMPLATE_SUCCESS = "DELETE_SMS_TEMPLATE_SUCCESS";
export const DELETE_SMS_TEMPLATE_FAIL = "DELETE_SMS_TEMPLATE_FAIL";

///smsoutbound/send
export const SEND_SMS_OUTBOUND = "SEND_SMS_OUTBOUND";
export const SEND_SMS_OUTBOUND_SUCCESS = "SEND_SMS_OUTBOUND_SUCCESS";
export const SEND_SMS_OUTBOUND_FAIL = "SEND_SMS_OUTBOUND_FAIL";

///smsoutbound/addressbook/lookup
export const GET_SMS_ADDRESS_BOOK = "GET_SMS_ADDRESS_BOOK";
export const GET_SMS_ADDRESS_BOOK_SUCCESS = "GET_SMS_ADDRESS_BOOK_SUCCESS";
export const GET_SMS_ADDRESS_BOOK_FAIL = "GET_SMS_ADDRESS_BOOK_FAIL";
